module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phand3-58f2d13af2773d6aff878ad126f8d33e.jpg";